module.exports = __webpack_public_path__ + "media/images/flags/ng-bca0a6624fd3ab0b7e70d3db574164c4.svg";